<div id="top-bar" class="top-header">
  <div class="container">
    <div class="row">
      <div class="col-lg-6">
        <div class="header-contact">
          <ul>
            <li>welcome to Naaora</li>
            <li><i class="ri-phone-fill"> </i> call_us 611300300</li>
          </ul>
        </div>
      </div>
      <div class="col-lg-6 text-end">
        <ul class="right-nav-about">
          <li class="right-nav-list">
            <div class="dropdown theme-form-select select-arrow">
              <!-- FIXME Selectro currency-->
              <!--<app-currency></app-currency>-->
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
